var $ = require('jquery');

require('../vendors/cycle/cycle')($);

var Cycle = function Cycle() {
	var $images = $('.banner .images');
	if($images.length) {
		$images.cycle({
			slides: '> .image',
			speed: 1000,
			fx: 'fadeout',
			pager: '> .cycle-pager',
			pagerTemplate: '<span></span>'
		});
	}
}

module.exports = Cycle;